<template>
	<div v-if="ratingsForm.stars && ratingsForm.stars !== ''" class="location-google-reviews">
		<GlobalIcon name="google-icon" :width="16" />
		<div class="location-google-reviews__divider"></div>
		<div class="location-google-reviews__container">
			<div class="location-google-reviews__stars">
				<GlobalRating
					:rating="ratingsForm.stars"
					readonly
					colorFilled="var(--primary-color)"
					colorEmpty="var(--primary-color)"></GlobalRating>
			</div>
			<p class="location-google-reviews__text">
				{{ ratingsForm.ratings }},
				<a :href="ratingsForm?.url" target="_blank" class="location-google-reviews__link">
					{{ ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
				</a>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const assignedLocations = inject<Ref<ILocationModel[]>>('assignedLocations')!

watch(
	() => assignedLocations.value,
	(v) => {
		if (v[0]) {
			if (v[0].countRatings && v[0].googleUrl && v[0].ratings) {
				ratingsForm.stars = v[0].ratings
				ratingsForm.ratings = v[0].ratings
				ratingsForm.ratingsCount = v[0].countRatings
				ratingsForm.url = v[0].googleUrl
			}
		}
	},
	{ deep: true, immediate: true },
)
</script>

<style lang="scss">
@import './GoogleReviews.scss';
</style>
